import React from 'react';

export function parseAndroidVersion(str) {
  if (!str) return null;
  const versionMatch = str.match(/AppVersion\s*:\s*([\d.]+)/);
  const codeMatch = str.match(/AppVersionCode\s*:\s*(\d+)/);
  if (!versionMatch && !codeMatch) return null;
  return {
    version: versionMatch?.[1] ?? null,
    code: codeMatch?.[1] ?? null,
  };
}

export function parseBinSlots(str) {
  if (!str) return [];
  const regex = /(NO\.\d+)\s*:\s*(\S+)/g;
  const slots = [];
  let match;
  while ((match = regex.exec(str)) !== null) {
    slots.push({ slot: match[1], value: match[2] });
  }
  return slots;
}

export function isVersionField(key) {
  return key === 'current_android_version' || key === 'current_bin_version';
}

function VersionField({ label, value, withCopy, onCopy, copyActive, layout = 'stacked' }) {
  const itemClass = `cs-vup-version-display__item${
    layout === 'inline' ? ' cs-vup-version-display__item--inline' : ''
  }`;

  return (
    <div className={itemClass}>
      <span className="cs-vup-version-display__label">{label}</span>
      <div className="cs-vup-version-display__value-row">
        <span className="cs-vup-version-display__value">{value}</span>
        {withCopy && onCopy && (
          <button
            type="button"
            className={`cs-vup-copy-icon${copyActive ? ' cs-vup-copy-icon--copied' : ''}`}
            title="Copy version"
            onClick={onCopy}
          >
            {copyActive ? '✓' : '⎘'}
          </button>
        )}
      </div>
    </div>
  );
}

export function StationInfoDisplay({ deviceId, chargingZone }) {
  return (
    <div className="cs-vup-station-info">
      <div className="cs-vup-station-info__block">
        <span className="cs-vup-station-info__label">Station ID</span>
        <span className="cs-vup-station-info__value">{deviceId}</span>
      </div>
      {chargingZone && (
        <div className="cs-vup-station-info__block">
          <span className="cs-vup-station-info__label">Charging Zone</span>
          <span className="cs-vup-station-info__value">{chargingZone}</span>
        </div>
      )}
    </div>
  );
}

export function VersionCellDisplay({ fieldKey, value }) {
  if (value === null || value === undefined || value === '') {
    return <span className="text-muted">-</span>;
  }

  if (fieldKey === 'current_android_version') {
    const parsed = parseAndroidVersion(value);
    if (!parsed) {
      return <span className="cs-vup-version-raw">{value}</span>;
    }
    return (
      <div className="cs-vup-version-display cs-vup-version-display--table">
        {parsed.version && <VersionField label="Version" value={parsed.version} />}
        {parsed.code && <VersionField label="Code" value={parsed.code} />}
      </div>
    );
  }

  if (fieldKey === 'current_bin_version') {
    const slots = parseBinSlots(value);
    if (slots.length === 0) {
      return <span className="cs-vup-version-raw">{value}</span>;
    }
    return (
      <div className="cs-vup-version-display cs-vup-version-display--table cs-vup-version-display--bin">
        {slots.map(({ slot, value: slotValue }) => (
          <VersionField key={slot} label={slot} value={slotValue} />
        ))}
      </div>
    );
  }

  return <>{value}</>;
}

export function ModalVersionDisplay({ value, type, onCopy, copyActive, showCopy }) {
  if (!value || value === '--') {
    return <span className="cs-vup-version-empty">No version data</span>;
  }

  if (type === 'android') {
    const parsed = parseAndroidVersion(value);
    if (!parsed) {
      return <span className="cs-vup-version-raw">{value}</span>;
    }
    return (
      <div className="cs-vup-version-display cs-vup-version-display--modal cs-vup-version-display--inline">
        {parsed.version && (
          <VersionField
            label="Version"
            value={parsed.version}
            layout="inline"
            withCopy={showCopy}
            onCopy={onCopy}
            copyActive={copyActive}
          />
        )}
        {parsed.code && <VersionField label="Code" value={parsed.code} layout="inline" />}
      </div>
    );
  }

  const slots = parseBinSlots(value);
  if (slots.length === 0) {
    return <span className="cs-vup-version-raw">{value}</span>;
  }
  return (
    <div className="cs-vup-version-display cs-vup-version-display--modal cs-vup-version-display--inline cs-vup-version-display--bin">
      {slots.map(({ slot, value: slotValue }, index) => (
        <VersionField
          key={slot}
          label={slot}
          value={slotValue}
          layout="inline"
          withCopy={showCopy && index === 0}
          onCopy={onCopy}
          copyActive={copyActive}
        />
      ))}
    </div>
  );
}
